<script setup>
const title = 'Evite a perda de leads';
const preventionTips = [
  'Responda ou adicione comentários rapidamente',
  'Ative notificações push no celular',
];
</script>

<template>
  <div class="flex space-x-4">
    <div
      class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-slate-100 dark:bg-slate-700"
    >
      <fluent-icon icon="info" size="20" />
    </div>
    <div class="flex-1 space-y-3">
      <h3 class="text-base font-semibold text-slate-800 dark:text-slate-100">
        {{ title }}
      </h3>
      <div class="text-slate-700 dark:text-slate-300">
        <ul class="ml-3 text-sm">
          <li v-for="(tip, index) in preventionTips" :key="index">
            {{ tip }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
